const alertLabels = [
    {
        title: 'General Information',
        type: 'columns',
        fields: [
            { label: '[ALERTNUMBER]', description: 'alert_number', visible: true },
            { label: '[TRACKING]', description: 'tracking', visible: true },
            { label: '[WEIGHT]', description: 'weight', visible: true },
            { label: '[DESCRIPTION]', description: 'description', visible: true }
        ]
    },
    {
        title: 'Customer',
        type: 'columns',
        fields: [
            { label: '[NOMBRECLIENTE]', description: 'customer_name', visible: true },
            { label: '[POBOXNUMBER]', description: 'pobox_number', visible: true },
            { label: '[SHIPPER]', description: 'shipper_name', visible: true },
            { label: '[CONSIGNEE]', description: 'consignee_email', visible: true }
        ]
    },
    {
        title: 'Agency',
        type: 'columns',
        fields: [
            { label: '[NOMBREAGENCIA]', description: 'agency_name', visible: true },
            {
                label: '[DIRECCIONAGENCIA]',
                description: 'agency_address',
                visible: true
            },
            { label: '[EMAILAGENCIA]', description: 'agency_email', visible: true },
            { label: '[TELEFONOAGENCIA]', description: 'agency_phone', visible: true }
        ]
    },
    {
        title: 'Company and Agent',
        type: 'columns',
        fields: [
            { label: '[COMPANYNAME]', description: 'company_name', visible: true },
            { label: '[FECHACREACION]', description: 'creation_date', visible: true },
            { label: '[AGENTE]', description: 'agent_name', visible: true }
        ]
    }
];

export default alertLabels;
